<template>
<div id="Home" class="full-height" :style="showLogin && {'overflow' : 'hidden'}">
  <nav-web class="position-fixed" v-if="platform === 'web'"/>
  <client-tab class="position-fixed" v-if="showClientTab" />
  <!--登录框-->
  <login-iframe />
  <div
      class="content-box"
      :class="{
    'content-box-web': platform === 'web',
    'content-box-gbr': softwareCode === 'AppGbr',
    'content-box-with-nav': showClientTab,
    'web-full-width': webFullWidthPages.includes($route.name),
    'no-padding': noPaddingPages.includes($route.name),
  }">
    <user-detail v-if="platform==='web'" />
    <nav-shop-basket v-if="(isIgnoreLogin || isLogin) && $route.meta.showBasket && !brandCode"  class="basket" :class="{'basket-web':isWebContentWidth}" />
    <menu-breadcrumb />
    <div v-if="isIgnoreLogin || isLogin" class="router-view">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" />
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import LoginIframe from '@/components/business/login/LoginIframe'
import UserDetail from '@/components/business/login/UserDetail'
import NavWeb from '@/components/layout/NavWeb'
import ClientTab from '@/components/layout/ClientTab'
import MenuBreadcrumb from '@/components/layout/MenuBreadcrumb.vue'
import NavShopBasket from '@/components/business/NavShopBasket'
import checkLoginMixin from '@/mixins/checkLoginMixin'
import Utils from '@/core/utils'
export default {
  name: 'Home',
  components: { LoginIframe, NavWeb, ClientTab, MenuBreadcrumb, NavShopBasket, UserDetail },
  mixins: [checkLoginMixin],
  data() {
    return {
      // 不希望内容有padding的页面，值为$route.Name
      noPaddingPages: ['DocDetail', 'GoodsList', 'ModuleList', 'ComponentList', 'StartSearch', 'SceneList', 'SceneComponentList'],
      // web端内容希望width100%的页面，值为$route.Name
      webFullWidthPages: ['Index', 'StartSearch', 'SceneList', 'SceneComponentList'],
    }
  },
  computed: {
    ...mapGetters({
      platform: 'platform',
      softwareCode: 'softwareCode',
      softwareVersion: 'softwareVersion',
      language: 'language',
      fromEntrance: 'fromEntrance',
      isSelectingEquipment: 'isSelectingEquipment',
      // 临时添加凯泉水泵独立页面，获取store中的brandCode
      brandCode: 'brandCode',
      showLogin: 'showLogin'
    }),
    isZh() {
      return this.language === 'zh_CN'
    },
    routeName() {
      return this.$route.name
    },
    isIgnoreLogin() {
      return !!this.$route.meta.ignoreLogin
    },
    isLogin() {
      return this.platform === 'web' ? !!this.user.strId : !!this.userToken
    },
    isWebContentWidth() {
      return this.platform === 'web' && !this.webFullWidthPages.includes(this.$route.name)
    },
    showClientTab() {
      if (!this.isZh) {
        return false
      }
      const showFlag = !this.isSelectingEquipment && this.$route.meta.module
      // 深化设计软件直接展示
      if (this.softwareCode === 'bimmake') {
        return showFlag
      }
      // 道路软件2.5以上版本, 其他数维插件，且0.45版本及以上，显示客户端tab。并且页面在某个tab下
      const versionCondition = this.softwareCode === 'AppGroad'
        ? Utils.isHigherVersion(this.softwareVersion, '2.5')
        : (this.platform === 'g' && this.softwareVersion - 0.45 >= 0)
      return versionCondition && showFlag
    },
  },
  watch: {
    isLogin(newVal) {
      if (!this.isIgnoreLogin && !newVal) {
        this.showLoginDialog()
      }
    },
  },
  async created() {
    const loginRes = await this.checkLogin()
    const isIgnoreLogin = this.isIgnoreLogin && (this.isIgnoreLogin === true || this.isIgnoreLogin.includes(this.platform))
    if (!loginRes && !isIgnoreLogin) {
      await this.showLoginDialog()
    }
  },
}
</script>

<style lang="less" scoped>
.content-box{
  display: flex;
  flex-direction: column;
  padding: 0 24px;
  min-height: 100%;
  position: relative;
  z-index: 0;
  &.no-padding{
    padding: 0;
  }
}
.position-fixed{
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  width: 100%;
}
.content-box-with-nav{
  padding-top: 40px!important;
}
.content-box-gbr {
  padding: unset ;
  padding-top: 40px;
  height: 100%;
}
.content-box-web{
  width: 1310px;
  margin: 0 auto;
  padding: 40px 0 0;
  min-height: calc(100% - 2px);
  &.web-full-width{
    width: 100%;
    margin: unset;
  }
  &.no-padding{
    padding: 40px 0 0;
  }
}
.basket{
  position: absolute;
  z-index: 10;
  top: 0;
  right: 24px;
  &.basket-web{
    right: 0;
  }
}
.router-view{
  flex: 1;
  display: flex;
  flex-direction: column;
}
.empty-content{
  margin-top: 200px;
  text-align: center;
  color: @theme-grey-3;
}
</style>
